/**
 * FOC free-gift claim (no third-party app).
 * - ?gift=1 sets a 7-day claim (Join adds FOCFREEGIFT)
 * - ?discount=CODE applies that code on Join → checkout
 * - ?billing=monthly|annual (+ optional ?tier=lite|premium) express-checks out
 *
 * Klaviyo buttons (Premium):
 *   .../pages/premium?gift=1&discount={% coupon_code 'FOCFREEGIFT' %}&billing=monthly
 *   .../pages/premium?gift=1&discount={% coupon_code 'FOCFREEGIFT' %}&billing=annual
 */
(function () {
  var STORAGE_KEY = 'foc_gift_claim';
  var BILLING_KEY = 'foc_gift_billing';
  var TIER_KEY = 'foc_gift_tier';
  var TTL_MS = 7 * 24 * 60 * 60 * 1000;

  function readClaim() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.expiresAt) return null;
      if (Date.now() > data.expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function setClaim(source, discountCode) {
    try {
      var existing = readClaim() || {};
      var code =
        discountCode != null && String(discountCode).trim() !== ''
          ? String(discountCode).trim()
          : existing.discount || '';
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          source: source || existing.source || 'manual',
          discount: code,
          expiresAt: Date.now() + TTL_MS,
        })
      );
    } catch (e) {
      /* private mode */
    }
  }

  function hasClaim() {
    return !!readClaim();
  }

  function getDiscount() {
    var claim = readClaim();
    return claim && claim.discount ? claim.discount : '';
  }

  function withDiscount(url, code) {
    if (!url || !code) return url;
    try {
      var outer = new URL(url, window.location.origin);
      var returnTo = outer.searchParams.get('return_to');
      if (!returnTo) {
        if (url.indexOf('/checkout') !== -1) {
          var direct = new URL(url, window.location.origin);
          direct.searchParams.set('discount', code);
          return direct.pathname + direct.search + direct.hash;
        }
        return url;
      }

      var addUrl = new URL(returnTo, window.location.origin);
      var checkoutTarget = addUrl.searchParams.get('return_to') || '/checkout';
      var checkout = new URL(checkoutTarget, window.location.origin);
      checkout.searchParams.set('discount', code);
      addUrl.searchParams.set('return_to', checkout.pathname + checkout.search);

      var rebuiltAdd = addUrl.pathname + '?' + addUrl.searchParams.toString();
      outer.searchParams.set('return_to', rebuiltAdd);
      return outer.pathname + '?' + outer.searchParams.toString() + outer.hash;
    } catch (e) {
      return url;
    }
  }

  function pickUrl(baseUrl, giftUrl) {
    var url = hasClaim() && giftUrl ? giftUrl : baseUrl;
    var code = getDiscount();
    if (code) url = withDiscount(url, code);
    return url;
  }

  function consumeQueryFlags() {
    try {
      var params = new URLSearchParams(window.location.search);
      var gift = params.get('gift');
      var discount = params.get('discount');
      var billing = (params.get('billing') || '').toLowerCase();
      var tier = (params.get('tier') || '').toLowerCase();
      var changed = false;

      if (gift === '1') {
        setClaim('query', discount || '');
        params.delete('gift');
        changed = true;
      } else if (discount) {
        setClaim('query-discount', discount);
        changed = true;
      }

      if (discount) {
        params.delete('discount');
        changed = true;
      }

      if (billing === 'monthly' || billing === 'annual') {
        try {
          sessionStorage.setItem(BILLING_KEY, billing);
        } catch (e) {
          /* ignore */
        }
        params.delete('billing');
        changed = true;
      }

      if (tier === 'lite' || tier === 'premium') {
        try {
          sessionStorage.setItem(TIER_KEY, tier);
        } catch (e) {
          /* ignore */
        }
        params.delete('tier');
        changed = true;
      }

      if (changed) {
        var next = window.location.pathname;
        var q = params.toString();
        if (q) next += '?' + q;
        next += window.location.hash || '';
        window.history.replaceState({}, '', next);
      }
    } catch (e) {
      /* ignore */
    }
  }

  function resolveExpressState() {
    var billing = null;
    var tier = null;
    try {
      billing = sessionStorage.getItem(BILLING_KEY);
      tier = sessionStorage.getItem(TIER_KEY);
    } catch (e) {
      return null;
    }
    if (billing !== 'monthly' && billing !== 'annual') return null;

    var pdpEl = document.querySelector('[data-foc-pdp-config]');
    if (pdpEl) {
      try {
        var pdpConfig = JSON.parse(pdpEl.textContent);
        var pdpState = pdpConfig[billing];
        if (pdpState && (pdpState.giftUrl || pdpState.url)) {
          return pdpState;
        }
      } catch (e) {
        /* ignore */
      }
    }

    var planEl = document.querySelector('[data-foc-plan-offer-config]');
    if (planEl) {
      try {
        var planConfig = JSON.parse(planEl.textContent);
        var planState = planConfig[billing];
        if (planState && (planState.giftUrl || planState.url)) {
          return planState;
        }
      } catch (e) {
        /* ignore */
      }
    }

    var offerEl = document.querySelector('[data-foc-offer-config]');
    if (offerEl) {
      try {
        var offerConfig = JSON.parse(offerEl.textContent);
        var useTier = tier === 'lite' || tier === 'premium' ? tier : 'premium';
        var plan = offerConfig[useTier];
        if (plan && plan[billing]) return plan[billing];
      } catch (e) {
        /* ignore */
      }
    }

    return null;
  }

  function tryExpressCheckoutRedirect() {
    var state = resolveExpressState();
    if (!state) return;

    try {
      sessionStorage.removeItem(BILLING_KEY);
      sessionStorage.removeItem(TIER_KEY);
    } catch (e) {
      /* ignore */
    }

    var url = pickUrl(state.url, state.giftUrl);
    if (url) window.location.replace(url);
  }

  window.FOCFreeGift = {
    hasClaim: hasClaim,
    setClaim: setClaim,
    pickUrl: pickUrl,
    readClaim: readClaim,
    getDiscount: getDiscount,
    withDiscount: withDiscount,
  };

  consumeQueryFlags();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryExpressCheckoutRedirect);
  } else {
    tryExpressCheckoutRedirect();
  }

  /**
   * Cap Free Gift at qty 1 (theme workaround — Admin has no quantity rules).
   */
  function giftVariantId() {
    var cfg = window.FOC_FREE_GIFT || {};
    return String(cfg.variantId || '45289044279431');
  }

  function giftSku() {
    var cfg = window.FOC_FREE_GIFT || {};
    return String(cfg.sku || 'FOCFREEGIFT');
  }

  function isGiftLine(item) {
    if (!item) return false;
    if (String(item.variant_id) === giftVariantId()) return true;
    if (item.sku && String(item.sku) === giftSku()) return true;
    return false;
  }

  function enforceGiftQtyCap() {
    var root = (window.routes && window.routes.cart_url) || '/cart';
    fetch(root + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var updates = {};
        var needsUpdate = false;
        cart.items.forEach(function (item) {
          if (isGiftLine(item) && item.quantity > 1) {
            updates[item.key] = 1;
            needsUpdate = true;
          }
        });
        if (!needsUpdate) return;
        return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'foc-free-gift' });
          } else {
            window.location.reload();
          }
        });
      })
      .catch(function () {
        /* ignore */
      });
  }

  function bindGiftQtyUi() {
    document.querySelectorAll('[data-foc-gift-locked="1"]').forEach(function (input) {
      input.readOnly = true;
      input.max = '1';
      if (parseInt(input.value, 10) > 1) input.value = '1';
      var wrap = input.closest('quantity-input');
      if (wrap) {
        wrap.querySelectorAll('.quantity__button').forEach(function (btn) {
          btn.disabled = true;
          btn.hidden = true;
        });
      }
    });
  }

  function initGiftQtyCap() {
    bindGiftQtyUi();
    enforceGiftQtyCap();
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('quantity__input')) return;
      if (t.getAttribute('data-foc-gift-locked') === '1') {
        t.value = '1';
        e.stopPropagation();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftQtyCap);
  } else {
    initGiftQtyCap();
  }
})();
